export default __webpack_public_path__ + "static/media/Joelma.3d60ac6d.jpg";